import {
  SET_HOMEPAGE_MAP_DISPLAY_MODE,
  SET_HOMEPAGE_MAP_REGION,
  SET_HOMEPAGE_ROLLOUT_VERSION_FILTER_EFFECT,
  TOGGLE_HOMEPAGE_ROLLOUT_STATUS_FILTER,
} from "../../../../actions";

export const setHomepageMapDisplayMode = (payload) => ({
  type: SET_HOMEPAGE_MAP_DISPLAY_MODE,
  payload,
});

export const setHomepageMapRegion = (payload) => ({
  type: SET_HOMEPAGE_MAP_REGION,
  payload,
});

export const setHomepageRolloutVersionFilterEffect = () => (dispatch) => {
  dispatch({ type: SET_HOMEPAGE_ROLLOUT_VERSION_FILTER_EFFECT });
};

export const toggleHomepageRolloutStatusFilter = (payload) => ({
  payload,
  type: TOGGLE_HOMEPAGE_ROLLOUT_STATUS_FILTER,
});
